// extracted by mini-css-extract-plugin
export var content = "main-module--content--c7104";
export var fadeInAnimation = "main-module--fadeInAnimation--4d37c";
export var topPaddingNone = "main-module--topPaddingNone--0a3d7";